import type { RouteSectionProps } from '@solidjs/router';
import { Router, useNavigate } from '@solidjs/router';
import { FileRoutes } from '@solidjs/start/router';
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query';
import { onMount, Suspense } from 'solid-js';
import { Toaster as CustomToaster } from '~/components/ui';
import { publicPaths } from '~/config/routes.config';
import { initSuperTokens } from '~/config/supertokens.config';
import { useAuth } from '~/hooks/auth/useAuth';
import './app.css';
import './styles/circular.font.css';

// Initialiser SuperTokens au chargement du module (client-side only)
if (typeof window !== 'undefined') {
  initSuperTokens();
}

const queryClient = new QueryClient();

function Layout(props: RouteSectionProps) {
  const { fetchUser } = useAuth();
  const navigate = useNavigate();

  // Charger le user au démarrage (client-side only)
  // SuperTokens gère automatiquement le refresh des tokens
  onMount(() => {
    // Pages qui ne nécessitent pas de session utilisateur
    const isPublicPath = publicPaths.some((path) => window.location.pathname.startsWith(path));

    if (!isPublicPath) {
      fetchUser().catch(() => {
        // Si le fetch échoue (pas de session), rediriger vers login
        navigate('/login', { replace: true });
      });
    }
  });

  return (
    <>
      <Suspense>{props.children}</Suspense>
      <CustomToaster />
    </>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router root={Layout}>
        <FileRoutes />
      </Router>
    </QueryClientProvider>
  );
}
